import React from 'react';
import {
  asSingleSelection,
  createTagOptionInput,
} from '../../../../../../components/Builder/EntitySelection/utils';
import EntitySelection from '../../../../../../components/Builder/EntitySelection';
import { useAppDispatch, useAppSelector } from '../../../../../../redux/hooks';
import { setSignificanceBreakdownField } from '../../../../../../redux/slices/oldBuilder';
import { ISelectedEntity } from '../../../../../../components/Builder/EntitySelection/types';
import { assertCondition } from '../../../../../../utils/types';
import {
  activeSchemaIdSelector,
  significanceErrorSelector,
} from '../../../../../../redux/selectors/builder';
import {
  FieldContext,
  IFieldFieldsFragment,
  TagOption,
} from '../../../../../../utils/apollo/graphqlSchema';
interface IProps {
  breakdownField: IFieldFieldsFragment | null;
}

const tags = [
  createTagOptionInput(TagOption.Field, {
    field: {
      events: [],
      func: null,
      context: FieldContext.Breakdown,
      arrayObjectContext: null,
    },
  }),
];

const SignificanceBreakdownField = ({ breakdownField }: IProps) => {
  const dispatch = useAppDispatch();

  const activeSchemaId = useAppSelector(activeSchemaIdSelector);
  const hasError = useAppSelector((state) =>
    significanceErrorSelector(state, 'criteriaField'),
  );

  const handleChange = (newField: ISelectedEntity) => {
    assertCondition(newField.__typename === 'Field');
    dispatch(setSignificanceBreakdownField({ newField }));
  };

  const handleRemove = () => {
    dispatch(setSignificanceBreakdownField({ newField: null }));
  };

  return (
    <EntitySelection
      schemaId={activeSchemaId}
      selectedEntities={asSingleSelection(breakdownField)}
      tags={tags}
      onRemoveEntity={handleRemove}
      onSelectEntity={handleChange}
      placeholder={'Select Field to Breakdown'}
      isError={hasError}
    />
  );
};

export default SignificanceBreakdownField;
